// Sets the database name that will be sent to rollbar with every rollbar log

export const setRollbarDatabase = (dbName: string | null) => {
  const rollbar = (window as any).Rollbar;

  if (rollbar) {
    rollbar.configure({
      payload: {
        person: {
          id: dbName || '',
          database: dbName || '',
        },
      },
    });
  }
};
